import type {ConversionSettings} from '@/generated';

/**
 * Pinnt in Convert-Request-Settings die Werte fest, die eine Konvertierung nie setzen darf –
 * aktuell `ChordInference.overwrite_existing: false` (eine Konvertierung löscht keine
 * Original-Akkorde). Das Backend honoriert bewusst ALLE gesendeten Werte („Backend ignoriert
 * nie"); dieser Pin ist die Frontend-Entscheidung dagegen und läuft durch JEDEN Convert-Pfad
 * (Auto/Global in useMusicUploadStore.startConversion, Per-Measure-Variants/Assemble über
 * useMeasureSelectionStore.buildSettings). Alle übrigen Felder bleiben unangetastet.
 *
 * Bewusst ein eigenes Modul (nicht in `stores/settings.ts`): viele Specs mocken
 * `@/stores/settings` mit einer Plain-Factory – eine dort exportierte pure Funktion wäre in
 * jedem dieser Mocks `undefined` und ließe `startConversion` erst zur Laufzeit crashen.
 * Guard: `convertPinsOverwrite.spec.ts`.
 */
export function pinConversionSettings(settings: ConversionSettings): ConversionSettings {
    return {
        ...settings,
        ChordInference: {...settings.ChordInference, overwrite_existing: false},
    };
}
